import { isUrlValid } from '@openx/utils/lib/isUrlValid';
import { useTranslation } from 'react-i18next';

import { maxDomainLength } from '../constants';
import { normalizeDomain } from '../utils/normalizeDomain';

export const isUrlWildcardValid = (url: string) => /^(\*\.)?[^*]*(\/(.)*)?$/.test(url);

export const useValidateDomain = () => {
  const { t } = useTranslation();

  return (domain: string): string => {
    if (!domain) return '';

    const normalized = normalizeDomain(domain);

    if (!normalized) return t('Invalid protocol. Only http and https are allowed.');

    const wildCardPrefix = '*.';
    const isWildcard = normalized.includes('*');
    const wildcardErrorMessage = t(
      "The wildcard position is invalid. '*' must be at the beginning of the URL, followed by '.', and should have no more than one '*'."
    );

    if (isWildcard && !isUrlWildcardValid(normalized)) {
      return wildcardErrorMessage;
    }

    if (normalized.length > maxDomainLength) {
      return `Domain length should not be greater than ${maxDomainLength} characters`;
    }

    return isUrlValid(normalized.replace(wildCardPrefix, '')) ? '' : t('Domain is invalid');
  };
};
